// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__sHALz","tabs__carousell":"style_tabs__carousell__Cs4fA","tabs-tab":"style_tabs-tab__LA7nQ","active":"style_active__ND_A1"};